// Global floating social button — visible on every page via App.js.
// Update the URL in one place (here) to swap it across the whole site.
const FACEBOOK_URL = 'https://www.facebook.com/';

const FloatingSocialButton = () => {
  return (
    <a
      href={FACEBOOK_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-facebook-link"
      aria-label="MedCare on Facebook"
      title="Follow MedCare on Facebook"
      style={{
        position: 'fixed',
        right: 16,
        bottom: 16,
        zIndex: 9999,
        width: 52,
        height: 52,
        borderRadius: '50%',
        background: '#1877f2',
        color: '#ffffff',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        boxShadow: '0 8px 22px rgba(24, 119, 242, 0.45), 0 2px 6px rgba(0,0,0,0.18)',
        transition: 'transform 0.18s ease, box-shadow 0.18s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px) scale(1.05)';
        e.currentTarget.style.boxShadow = '0 12px 28px rgba(24, 119, 242, 0.55), 0 4px 10px rgba(0,0,0,0.22)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0) scale(1)';
        e.currentTarget.style.boxShadow = '0 8px 22px rgba(24, 119, 242, 0.45), 0 2px 6px rgba(0,0,0,0.18)';
      }}
    >
      <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.51 1.5-3.9 3.78-3.9 1.1 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.77l-.44 2.91h-2.33V22c4.78-.76 8.43-4.92 8.43-9.94z" />
      </svg>
    </a>
  );
};

export default FloatingSocialButton;
